/**
 * this pattern is used to create a singleton instance of the queryKeys
 * prevent the same queryKey from being used in multiple places
 */
export const queryKeys = {
  QUESTIONDATA: "question",
  TIMES: "times",
  MYPAGE: "mypage",
};
